// @ts-nocheck cdea86da
import { array } from '#packages/util';
import wixFormsConstants from '../../contact/wixForms/constants';
import * as wixFormsUtils from '../../contact/wixForms/utils';

const addForm = (structure) => {
  const form = wixFormsUtils.getFormWidget({
    layout: {
      width: 505,
      height: 160,
      x: 314,
      y: 181,
      scale: 1,
      rotationInDegrees: 0,
      anchors: [
        {
          distance: -7,
          originalValue: 354,
          type: 'BOTTOM_TOP',
          locked: true,
          targetComponent: 'comp-im24czkd',
        },
      ],
      fixedPosition: false,
    },
    id: 'comp-im24czkq',
    mobileLayout: {
      width: 262,
      height: 273,
      scale: 1,
      rotationInDegrees: 0,
      fixedPosition: false,
    },
  });

  // add form to
  // components: [
  //     component_0: {
  //         components: [
  //             component_00,
  //             form,
  //             ...
  //         ]
  //     },
  // ]
  return {
    ...structure,
    components: array.immutableSplice(structure.components, 0, 1, {
      ...structure.components[0],
      components: array.immutableSplice(
        structure.components[0].components,
        1,
        0,
        form,
      ),
    }),
  };
};

export default (onDrop, onClick) => (item) => {
  onDrop = onDrop(wixFormsConstants.FormPreset.LIGHTBOX_CONTACT04);
  onClick = onClick(wixFormsConstants.FormPreset.LIGHTBOX_CONTACT04);

  return {
    ...item,
    onDrop,
    onClick,
    structure: addForm(item.structure),
  };
};
